import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Output, OnInit, DestroyRef, inject, EventEmitter } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbToastModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PolicyService } from '@services/policy.service';
import { RequestService } from '@services/request.service';
import Swal from 'sweetalert2'
import { CoreModule } from 'app/modules/core.module';
import { InsuredService } from '@services/insured.service';
import { StateDisplayComponent } from 'app/shared/state-display/state-display.component';
import { apiResponse, apiLog, apiError } from 'app/shared/api-response';

@Component({
  selector: 'app-additionals',
  standalone: true,
  imports: [CoreModule, NgbTooltipModule, NgbToastModule, StateDisplayComponent],
  providers: [PolicyService, RequestService],
  templateUrl: './additionals.component.html',
  styleUrls: ['./additionals.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdditionalsComponent {

  @Input() insured: any
  @Input() editData: boolean = false
  @Input() policy: any
  @Input() permissions: any
  @Output() change = new EventEmitter()

  private _insuredService = inject(InsuredService)
  private _requestService = inject(RequestService)
  private fb = inject(FormBuilder)
  private modalService: NgbModal = inject(NgbModal)
  private config = inject(NgbModalConfig)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  private modalOptions = {
    size: 'lg',
    scrollable: true,
    animation: true,
  }

  protected showSpinner = true
  protected family = []

  protected Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    width: 500,
    timer: 5000,
    timerProgressBar: true
  })


  public exclutionForm = this.fb.group({
    insuredId: [null, Validators.required],
    policyId: [null, Validators.required],
    dateFinish: [null, Validators.required],
    voteDetail: [null, Validators.required]
  })

  ngOnInit() {
    this.config.backdrop = 'static';
    this.config.keyboard = false;

    this.getFamily()
  }

  ngOnChanges(): void {
    this.getFamily()
  }

  getFamily() {
    if (this.policy) {
      this._insuredService.getFamily(this.insured._id, this.policy.policyId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        apiLog(res, 'Carga de grupo familiar')
        this.family = res ?? []
        this.showSpinner = false
        this.cdr.markForCheck()
      })
    } else {
      this.showSpinner = false
    }
  }

  changeInsured(insured: any) {
    this.change.emit(insured)
  }

  open(content: any, insured: any) {
    this.exclutionForm.patchValue({ insuredId: insured, policyId: this.policy.policyId })
    this.modalService.open(content, this.modalOptions)
  }

  exclusionInsured() {
    if (this.exclutionForm.valid) {
      this.showLoading()

      this._requestService.exclution(this.exclutionForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (res) => {
          Swal.close()
          this.modalService.dismissAll()
          if (res?.status == 200) {
            apiResponse(res, 'Exclusión generada')
            this.exclutionForm.reset()
          } else {
            apiResponse(res, 'Exclusión procesada con advertencias')
          }
        },
        error: (err) => {
          Swal.close()
          apiError(err, 'Error al generar exclusión')
        }
      })
    }
  }

  showLoading() {
    Swal.fire({
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    })
  }

}
